
import {initWebComponent} from "@/helpers/web-component-helper";
import {getAnimationDuration, zoomIn} from "@/helpers/ol/ol-event-helper";

const template = document.createElement('template');
template.innerHTML = `<footer-button data-title="Zoom in" data-icon="fa fa-plus"></footer-button>`;

export class OlZoomInComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            zoomIn()
            this.firstChild.firstChild.classList.add('active')
            setTimeout(() => {
                this.firstChild.firstChild.classList.remove('active')
            }, getAnimationDuration())
        });
    }
}

